import { Client, mapUrl } from "../client";
import {
	InteractionDto,
	SuperviseCallDto,
	EjectParticipantRequest,
	InteractionFilterData,
	MonitoringStartResponse,
} from "../models";
import { Controller, Endpoint } from "..";

export const fetchAllActiveInteractionsFn = (
	filterData: InteractionFilterData
) => {
	if (!filterData) {
		filterData = { queueIds: [], types: [] };
	}

	return Client.instance.post<InteractionDto[]>(
		mapUrl(
			Controller.SupervisedInteractions,
			Endpoint.AllActiveInteractions
		),
		filterData
	);
};

export const fetchAllWaitingInteractionsFn = (
	filterData: InteractionFilterData
) => {
	if (!filterData) {
		filterData = { queueIds: [], types: [] };
	}

	return Client.instance.post<InteractionDto[]>(
		mapUrl(
			Controller.SupervisedInteractions,
			Endpoint.AllWaitingInteractions
		),
		filterData
	);
};

export const startMonitoring = (data: SuperviseCallDto) => {
	return Client.instance.post<MonitoringStartResponse>(
		mapUrl(Controller.SupervisorVoice, Endpoint.MonitoringStart),
		data
	);
};

export const switchMonitoring = (data: SuperviseCallDto) => {
	return Client.instance.post(
		mapUrl(Controller.SupervisorVoice, Endpoint.MonitoringSwitch),
		data
	);
};

export const stopMonitoring = (data: EjectParticipantRequest) => {
	return Client.instance.post(
		mapUrl(Controller.SupervisorVoice, Endpoint.MonitoringStop),
		data
	);
};
